import { put, takeLatest, call } from 'redux-saga/effects'
import { programEditingActions } from './ProgramEditingActions'
import { programEditingReducers } from './ProgramEditingSlice'
import getGovernmentGrhPrograms, {
  getTransitAgencies,
  getCouponMerchants,
} from './ProgramEditingServices'

function* setGrhTransactionUsesSaga(action: any) {
  yield put(programEditingReducers.setGrhTransactionUses(action.payload))
}

function* setGrhActiveOptionsSaga(action: any) {
  yield put(programEditingReducers.setGrhActiveOptions(action.payload))
}

function* setGrhActiveMerchantIdsSaga(action: any) {
  yield put(programEditingReducers.setGrhActiveMerchantIds(action.payload))
}

function* setMicromobilityBudgetSaga(action: any) {
  yield put(programEditingReducers.setMicromobilityBudget(action.payload))
}

function* setMicromobilityActiveOptionsSaga(action: any) {
  yield put(
    programEditingReducers.setMicromobilityActiveOptions(action.payload)
  )
}

function* setMicromobilityActiveMerchantIdsSaga(action: any) {
  yield put(
    programEditingReducers.setMicromobilityActiveMerchantIds(action.payload)
  )
}

function* setFlexBudgetSaga(action: any) {
  yield put(programEditingReducers.setFlexBudget(action.payload))
}

function* setFlexBudgetCycleSaga(action: any) {
  yield put(programEditingReducers.setFlexBudgetCycle(action.payload))
}

function* setFlexOneTimePurchaseSaga(action: any) {
  yield put(programEditingReducers.setFlexOneTimePurchase(action.payload))
}

function* setFlexRolloverBudgetSaga(action: any) {
  yield put(programEditingReducers.setFlexRolloverBudget(action.payload))
}

function* setFlexActiveOptionsSaga(action: any) {
  yield put(programEditingReducers.setFlexActiveOptions(action.payload))
}

function* setFlexActiveMerchantIdsSaga(action: any) {
  yield put(programEditingReducers.setFlexActiveMerchantIds(action.payload))
}

function* setTransitPassPurchaseTypeSaga(action: any) {
  yield put(programEditingReducers.setTransitPassPurchaseType(action.payload))
}

function* setTransitPassWalletTopUpEnabledSaga(action: any) {
  yield put(
    programEditingReducers.setTransitPassWalletTopUpEnabled(action.payload)
  )
}

function* setTransitPassBudgetSaga(action: any) {
  yield put(programEditingReducers.setTransitPassBudget(action.payload))
}

function* setTransitPassDeliveryMechanismSaga(action: any) {
  yield put(
    programEditingReducers.setTransitPassDeliveryMechanism(action.payload)
  )
}

function* setTransitPassAgencyIdsSaga(action: any) {
  yield put(programEditingReducers.setTransitPassAgencyIds(action.payload))
}

function* setTransitPassAgenciesEnabledSaga(action: any) {
  yield put(programEditingReducers.setTransitPassAgenciesEnabled(action.payload))
}

function* getTransitAgenciesSaga() {
  const response = yield call(getTransitAgencies)
  yield put(programEditingReducers.setTransitPassAvailableAgencies(response))
}

function* setCouponMerchantIdsSaga(action: any) {
  yield put(programEditingReducers.setCouponMerchantIds(action.payload))
}

function* setCouponMerchantsEnabledSaga(action: any) {
  yield put(programEditingReducers.setCouponMerchantsEnabled(action.payload))
}

function* getCouponMerchantsSaga() {
  const response = yield call(getCouponMerchants)
  yield put(programEditingReducers.setCouponAvailableMerchants(response))
}

function* setCouponCodeSaga(action: any) {
  yield put(programEditingReducers.setCouponCode(action.payload))
}

function* setReportedUsageMerchantsSaga(action: any) {
  yield put(programEditingReducers.setReportedUsageMerchants(action.payload))
}

function* setQtfBenefitsSaga(action: any) {
  yield put(programEditingReducers.setQtfBenefits(action.payload))
}

function* setQtfEmployerContributionsSaga(action: any) {
  yield put(programEditingReducers.setQtfEmployerContributions(action.payload))
}

function* setQtfFinalizeAllocationSaga(action: any) {
  yield put(programEditingReducers.setQtfFinalizeAllocation(action.payload))
}

function* changeQtfPayrollScheduleSaga(action: any) {
  yield put(programEditingReducers.setQtfPayrollSchedule(action.payload))
}

function* changeQtfMaxAllocationLimitSaga(action: any) {
  yield put(programEditingReducers.setQtfMaxAllocationLimit(action.payload))
}

function* applyRehydrateStateSaga(action: any) {
  yield put(programEditingReducers.rehydrateState(action.payload))
}

function* clearStateSaga() {
  yield put(programEditingReducers.setInitialState())
}

function* getGovernmentGrhProgramsSaga() {
  const response = yield call(getGovernmentGrhPrograms)
  yield put(programEditingReducers.setGovernmentGrhPrograms(response))
}

export function* programEditingSaga() {
  yield takeLatest(
    programEditingActions.changeGrhTransactionUses.type,
    setGrhTransactionUsesSaga
  )
  yield takeLatest(
    programEditingActions.changeGrhActiveOptions.type,
    setGrhActiveOptionsSaga
  )
  yield takeLatest(
    programEditingActions.changeGrhActiveMerchantIds.type,
    setGrhActiveMerchantIdsSaga
  )
  yield takeLatest(
    programEditingActions.changeMicromobilityBudget.type,
    setMicromobilityBudgetSaga
  )
  yield takeLatest(
    programEditingActions.changeMicromobilityActiveOptions.type,
    setMicromobilityActiveOptionsSaga
  )
  yield takeLatest(
    programEditingActions.changeMicromobilityActiveMerchantIds.type,
    setMicromobilityActiveMerchantIdsSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexBudget.type,
    setFlexBudgetSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexBudgetCycle.type,
    setFlexBudgetCycleSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexOneTimePurchase.type,
    setFlexOneTimePurchaseSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexRolloverBudget.type,
    setFlexRolloverBudgetSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexActiveOptions.type,
    setFlexActiveOptionsSaga
  )
  yield takeLatest(
    programEditingActions.changeFlexActiveMerchantIds.type,
    setFlexActiveMerchantIdsSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassPurchaseType.type,
    setTransitPassPurchaseTypeSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassWalletTopUpEnabled.type,
    setTransitPassWalletTopUpEnabledSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassBudget.type,
    setTransitPassBudgetSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassDeliveryMechanism.type,
    setTransitPassDeliveryMechanismSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassAgencyIds.type,
    setTransitPassAgencyIdsSaga
  )
  yield takeLatest(
    programEditingActions.changeTransitPassAgenciesEnabled.type,
    setTransitPassAgenciesEnabledSaga
  )
  yield takeLatest(
    programEditingActions.getTransitAgencies.type,
    getTransitAgenciesSaga
  )
  yield takeLatest(
    programEditingActions.changeCouponMerchantIds.type,
    setCouponMerchantIdsSaga
  )
  yield takeLatest(
    programEditingActions.changeCouponMerchantsEnabled.type,
    setCouponMerchantsEnabledSaga
  )
  yield takeLatest(
    programEditingActions.getCouponMerchants.type,
    getCouponMerchantsSaga
  )
  yield takeLatest(
    programEditingActions.changeCouponCode.type,
    setCouponCodeSaga
  )
  yield takeLatest(
    programEditingActions.changeReportedUsageMerchants.type,
    setReportedUsageMerchantsSaga
  )
  yield takeLatest(
    programEditingActions.changeQtfBenefits.type,
    setQtfBenefitsSaga
  )
  yield takeLatest(
    programEditingActions.changeQtfEmployerContributions.type,
    setQtfEmployerContributionsSaga
  )
  yield takeLatest(
    programEditingActions.changeQtfFinalizeAllocation.type,
    setQtfFinalizeAllocationSaga
  )
  yield takeLatest(
    programEditingActions.changeQtfPayrollSchedule.type,
    changeQtfPayrollScheduleSaga
  )
  yield takeLatest(
    programEditingActions.changeQtfMaxAllocationLimit.type,
    changeQtfMaxAllocationLimitSaga
  )
  yield takeLatest(
    programEditingActions.applyRehydrateState.type,
    applyRehydrateStateSaga
  )
  yield takeLatest(programEditingActions.clearState.type, clearStateSaga)
  yield takeLatest(
    programEditingActions.getGovernmentGrhPrograms.type,
    getGovernmentGrhProgramsSaga
  )
}

export default programEditingSaga
